import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=6db7e150"
import script from "./Commissions.vue?vue&type=script&lang=js"
export * from "./Commissions.vue?vue&type=script&lang=js"
import style0 from "./Commissions.vue?vue&type=style&index=0&id=6db7e150&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports